import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';

export interface PanelProps {
  title?: ReactNode;
  /** 見出し右側の操作 */
  actions?: ReactNode;
  /** 見出し下の補足 */
  description?: ReactNode;
  children: ReactNode;
  /** 内側余白なし（表を全幅で置く場合） */
  flush?: boolean;
  className?: string;
}

/** 白地のセクション枠。フォームのブロック分け・ウィジェット枠に使う */
export function Panel({ title, actions, description, children, flush, className }: PanelProps) {
  return (
    <section className={cx('bs-panel', flush && 'is-flush', className)}>
      {(title || actions) && (
        <header className="bs-panel__header">
          <div>
            {title && <h2 className="bs-panel__title">{title}</h2>}
            {description && <p className="bs-panel__desc">{description}</p>}
          </div>
          {actions && <div className="bs-panel__actions">{actions}</div>}
        </header>
      )}
      <div className="bs-panel__body">{children}</div>
    </section>
  );
}
